import classNames from 'classnames';
import React from 'react';
import { ReactComponent as MoreIcon } from './icons/more.svg';
import './MoreButton.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
}

export default function MoreButton({ className, ...props }: Props) {
  return <button className={classNames('MoreButton', className)} {...props}>
    <MoreIcon className={'icon'} />
  </button>
}
